<template>
  <div class="content blacklist">
    <div class="box">
      <div class="title">
        结算设置
      </div>
      <el-row :gutter="40">
        <el-col :span="5">
          <div class=" textAlign">
            <span>佣金计算方式</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div>
            <el-radio-group v-model="item_obj.type">
              <el-radio label="1">买单金额</el-radio>
              <el-radio label="2">实际支付</el-radio>
            </el-radio-group>
          </div>
          <div class="color">
            买单金额：[会员价-满减（或折扣）]*佣金比例
          </div>
          <div class="color">
            实际支付：[实际支付金额-运费]*佣金比例
          </div>
        </el-col>
      </el-row>
      <!-- 消费金额 -->
      <el-row :gutter="40">
        <el-col :span="5">
          <div class=" textAlign">
            <span>最低提现额度</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div style="display:flex; width: 200px;align-items: center">
            <el-input size="small" v-model="item_obj.min"  type="number"></el-input><div class="inputMargin">元</div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="5">
          <div class=" textAlign">
            <span>佣金提现手续费</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div style="display:flex; width: 200px;align-items: center">
            <el-input size="small" v-model="item_obj.fee_rate" type="number"></el-input><div class="inputMargin">%</div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="5">
          <div class=" textAlign">
            <span>免手续费区间</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div style="display:flex; width: 200px;align-items: center">
            <el-input size="small" min="0" v-model="item_obj.free_min" type="number"></el-input> 
            <div style="margin: 0 5px ;">至</div> 
            <el-input size="small" :min="item_obj.free_min" v-model="item_obj.free_max" type="number"></el-input>
            <div class="inputMargin">元</div> 
          </div>
          <div class="color">
            当提现手续费金额在此区间时，不扣除提现手续费
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="5">
          <div class=" textAlign">
            <span>结算天数</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div style="display:flex;align-items: center">
            <div class="">订单确认收货后</div>
            <el-input size="small" v-model="item_obj.settle_day" type="number" style="width: 75px"></el-input>
            <div class="inputMargin">天</div>
            <div class="inputMargin">能申请提现</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="box">
      <div class="title">结算设置</div>
      <el-row :gutter="40">
        <el-col :span="5">
          <div class=" textAlign">
            <span>提现审核</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div>
            <el-radio-group v-model="item_obj.audit_type">
              <el-radio label="1">手动审核</el-radio>
              <el-radio label="2">自动审核</el-radio>
            </el-radio-group>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="5">
          <div class=" textAlign">
            <span>自动打款</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div>
            <el-radio-group v-model="item_obj.auto_account">
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">启用</el-radio>
            </el-radio-group>
          </div>
          <div class="color">
            提现审核通过将自动打款（支付宝和银行卡仍需要手动打款）
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="5">
          <div class=" textAlign">
            <span>提现方式</span>
          </div>
        </el-col>
        <el-col :span="19">
          <el-checkbox-group v-model="checkList" @change="checkMethods">
            <el-checkbox label="1">提现到商城余额</el-checkbox>
            <el-checkbox label="2">提现到微信钱包</el-checkbox>
            <el-checkbox label="3">提现到支付宝</el-checkbox>
            <el-checkbox label="4">提现到银行卡</el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>
    </div>
    <!-- 底部提交 -->

    <div class="bottom">
      <el-button>取消</el-button>
      <el-button type="primary" @click="save_set">确定</el-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { settle_setting, set_settingDetail } from "@/api/user";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      manualShow: false,
      checkList: [],
      item_obj: {
        type: 2,
        min: 0,
        fee_rate: 0,
        free_min: 0,
        free_max: 0,
        settle_day: 1,
        audit_type: '1',
        auto_account: 0,
      }
    };
  },
  mounted() {
    this.get_detail();
  },
  methods: {
    // 提现方式
    checkMethods(value){
      console.log("值更新", value);
      var arr = value;
      this.manualShow = value.some(item =>{return item =='2'});
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    async save_set() {
      try {
        if(this.item_obj.hasOwnProperty('create_time')) {
          // this.item_obj.delete('create_time');
          // this.item_obj.delete('update_time');
          delete this.item_obj.create_time;
          delete this.item_obj.update_time;
        }
        var data = {
          app_id: this.app_id,
          ...this.item_obj,
          withraw_wallet: this.checkList.join(',')
        }
        const res = await settle_setting(data);
        if(res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async get_detail() {
      try {
        var data = { app_id: this.app_id };
        const res = await set_settingDetail(data);
        var arr_key = Object.keys(this.item_obj);
        if (res.code == 200) {
          if (res.data.withraw_wallet) this.checkList = res.data.withraw_wallet.split(',');
          for (let i in res.data) {
            if (res.data[i]) res.data[i] = res.data[i].toString();
          }
          this.item_obj = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 20px 60px 20px;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  background: #f2f2f6;
  font-size: 14px;
  overflow: scroll;
  position: relative;
  .el-row{
    margin: 22px 22px;
  }
  .el-col{
    padding: 0;
    // 商品表
    .productcart{
      width: 500px;
      .top {
        padding: 6px;
        background: #f2f2f6;
        display: flex;
        justify-content: space-between;
      }
      .cont{
        display: flex;
        justify-content: space-between;
      }
      div{
        padding: 6px;
        line-height: 16x;
      }
    }
  }
  .box{
    background: #fff;
    margin-top: 20px;
    padding: 10px 0px;
    .title{
      font-weight: 550;
      padding: 10px 0px 10px 20px;
    }
    // 样式
    .textAlign{
      text-align: right;
    }
    .color{
      margin: 10px 0;
      color: #999;
    }
    .inputMargin{
      margin: 0 6px;
    }
  }
  // 底部
  .bottom{
    position: fixed;
    bottom : 0;
    border-top : 1px solid #f2f2f6;
    height: 60px;
    line-height: 60px;
    background: #fff;
    text-align: center;
    width: 100%;
    padding: 0 20px;
  }
}

</style>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 98px;
    height: 98px;
    line-height: 98px;
    text-align: center;
  }
  .avatar {
    width: 98px;
    height: 98px;
    display: block;
  }
</style>